var map = {
	"./adventure_potion.png": 9987,
	"./axe.png": 8089,
	"./bg.png": 6736,
	"./big_health_potion.png": 2086,
	"./bow.png": 7797,
	"./box.png": 7202,
	"./button.png": 3745,
	"./doge_raid_seal.png": 4999,
	"./dungeon_reset.png": 1639,
	"./full_health_potion.png": 87,
	"./lootbox_key.png": 544,
	"./medium_health_potion.png": 3081,
	"./pickaxe.png": 9496,
	"./placeholder.png": 7946,
	"./sickle.png": 650,
	"./small_health_potion.png": 3561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4666;